import * as THREE from 'three';
import { SETTINGS } from '../SETTINGS';

export const createScene = () => {
  const scene = new THREE.Scene();
  scene.background = null;
  return scene;
};

export const createRenderer = (canvas: HTMLCanvasElement) => {
  const renderer = new THREE.WebGLRenderer({
    canvas,
    alpha: false,
    antialias: true
  });
  renderer.setPixelRatio(window.devicePixelRatio);
  // Ensure initial frame matches page background (opaque)
  renderer.setClearColor(0xf3f3f3, 1);
  return renderer;
};

export const createCamera = (aspect: number) => {
  const camera = new THREE.PerspectiveCamera(
    SETTINGS.camera.fov,
    aspect,
    SETTINGS.camera.near,
    SETTINGS.camera.far
  );
  camera.position.set(
    SETTINGS.camera.position.x,
    SETTINGS.camera.position.y,
    SETTINGS.camera.position.z
  );
  camera.lookAt(
    SETTINGS.camera.lookAt.x,
    SETTINGS.camera.lookAt.y,
    SETTINGS.camera.lookAt.z
  );
  return camera;
};

export const createOrthoCamera = (width: number, height: number) => {
  const halfWidth = width * 0.5;
  const halfHeight = height * 0.5;
  const camera = new THREE.OrthographicCamera(
    -halfWidth,
    halfWidth,
    halfHeight,
    -halfHeight,
    SETTINGS.camera.near,
    SETTINGS.camera.far
  );
  camera.position.set(0, 0, 1);
  camera.lookAt(0, 0, 0);
  return camera;
};
